import React from "react"
import styles from "./services.module.scss"
import BlackHoleCanvas from "./BlackHoleCanvas"

function MyServices() {
  return (
    <section className={styles.section}>
      <BlackHoleCanvas />
      <div className={styles.container}>
        <div className={styles.techstackContent}>
          <div className={styles.header}>
            <p className={styles.subtitle}>Skills</p>
            <h2 className={styles.title}>
              Tech <span className={styles.gradient}>Stack</span>
            </h2>
            <p className={styles.subtext}>
              Cutting-edge tools and frameworks for building the future
            </p>
          </div>

          <div className={styles.techstackPyramid}>
            {/* ROW 1 (10 items - Languages & Core Frontend) */}
            <div className={styles.techstackRow}>
              <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="JavaScript" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" className={styles.techIcon} alt="JavaScript" />
                </div>
                <span className={styles.techName}>JavaScript</span>
              </a>
              <a href="https://typescriptlang.org" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="TypeScript" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" className={styles.techIcon} alt="TypeScript" />
                </div>
                <span className={styles.techName}>TypeScript</span>
              </a>
              <a href="https://react.dev" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="React" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" className={styles.techIcon} alt="React" />
                </div>
                <span className={styles.techName}>React</span>
              </a>
              <a href="https://reactnative.dev" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="React Native" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" className={styles.techIcon} alt="React Native" />
                </div>
                <span className={styles.techName}>React Native</span>
              </a>
              <a href="https://nextjs.org" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Next.js" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-line.svg" className={`${styles.techIcon} ${styles.invert}`} alt="Next.js" />
                </div>
                <span className={styles.techName}>Next.js</span>
              </a>
              <a href="https://ant.design" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Ant Design" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/antdesign/antdesign-original.svg" className={styles.techIcon} alt="Ant Design" />
                </div>
                <span className={styles.techName}>Ant Design</span>
              </a>
              <a href="https://developer.mozilla.org/en-US/docs/Web/HTML" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="HTML5" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" className={styles.techIcon} alt="HTML5" />
                </div>
                <span className={styles.techName}>HTML5</span>
              </a>
              <a href="https://developer.mozilla.org/en-US/docs/Web/CSS" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="CSS3" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" className={styles.techIcon} alt="CSS3" />
                </div>
                <span className={styles.techName}>CSS3</span>
              </a>
              <a href="https://sass-lang.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Sass" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg" className={styles.techIcon} alt="Sass" />
                </div>
                <span className={styles.techName}>Sass</span>
              </a>
              <a href="https://redux.js.org" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Redux" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg" className={styles.techIcon} alt="Redux" />
                </div>
                <span className={styles.techName}>Redux</span>
              </a>
            </div>

            {/* ROW 2 (9 items - Backend, Languages & Databases) */}
            <div className={styles.techstackRow}>
              <a href="https://nodejs.org" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Node.js" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" className={styles.techIcon} alt="Node.js" />
                </div>
                <span className={styles.techName}>Node.js</span>
              </a>
              <a href="https://expressjs.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Express" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" className={`${styles.techIcon} ${styles.invert}`} alt="Express" />
                </div>
                <span className={styles.techName}>Express</span>
              </a>
              <a href="https://graphql.org" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="GraphQL" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg" className={styles.techIcon} alt="GraphQL" />
                </div>
                <span className={styles.techName}>GraphQL</span>
              </a>
              <a href="https://restfulapi.net/" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="REST API" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <svg viewBox="0 0 24 24" className={styles.techIcon} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="16" y="16" width="6" height="6" rx="1" />
                    <rect x="2" y="16" width="6" height="6" rx="1" />
                    <rect x="9" y="2" width="6" height="6" rx="1" />
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" />
                    <path d="M12 8v4" />
                  </svg>
                </div>
                <span className={styles.techName}>REST API</span>
              </a>
              <a href="https://python.org" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Python" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" className={styles.techIcon} alt="Python" />
                </div>
                <span className={styles.techName}>Python</span>
              </a>
              <a href="https://java.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Java" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg" className={styles.techIcon} alt="Java" />
                </div>
                <span className={styles.techName}>Java</span>
              </a>
              <a href="https://dart.dev" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Dart" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg" className={styles.techIcon} alt="Dart" />
                </div>
                <span className={styles.techName}>Dart</span>
              </a>
              <a href="https://mongodb.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="MongoDB RAG" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" className={styles.techIcon} alt="MongoDB" />
                </div>
                <span className={styles.techName}>MongoDB RAG</span>
              </a>
              <a href="https://postgresql.org" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="PostgreSQL" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" className={styles.techIcon} alt="PostgreSQL" />
                </div>
                <span className={styles.techName}>PostgreSQL</span>
              </a>
            </div>

            {/* ROW 3 (8 items - Data Stores, Enterprise & CRM) */}
            <div className={styles.techstackRow}>
              <a href="https://redis.io" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Redis" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg" className={styles.techIcon} alt="Redis" />
                </div>
                <span className={styles.techName}>Redis</span>
              </a>
              <a href="https://salesforce.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Salesforce" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/salesforce/salesforce-original.svg" className={styles.techIcon} alt="Salesforce" />
                </div>
                <span className={styles.techName}>Salesforce</span>
              </a>
              <a href="https://genesys.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Genesys Cloud" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <svg viewBox="0 0 24 24" className={`${styles.techIcon} ${styles.genesysColor}`} fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c4.85 0 8.87-3.46 9.74-8H19.6c-.8 3.39-3.86 6-7.6 6-4.42 0-8-3.58-8-8s3.58-8 8-8c3.74 0 6.8 2.61 7.6 6h2.14C20.87 5.46 16.85 2 12 2zm3.5 10c0 1.93-1.57 3.5-3.5 3.5S8.5 13.93 8.5 12s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5z" />
                  </svg>
                </div>
                <span className={styles.techName}>Genesys Cloud</span>
              </a>
              <a href="https://gatsbyjs.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Gatsby" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gatsby/gatsby-original.svg" className={styles.techIcon} alt="Gatsby" />
                </div>
                <span className={styles.techName}>Gatsby</span>
              </a>
              <a href="https://flutter.dev" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Flutter" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg" className={styles.techIcon} alt="Flutter" />
                </div>
                <span className={styles.techName}>Flutter</span>
              </a>
              <a href="https://webpack.js.org" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Webpack" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/webpack/webpack-original.svg" className={styles.techIcon} alt="Webpack" />
                </div>
                <span className={styles.techName}>Webpack</span>
              </a>
              <a href="https://figma.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Figma" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" className={styles.techIcon} alt="Figma" />
                </div>
                <span className={styles.techName}>Figma</span>
              </a>
              <a href="https://code.visualstudio.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="VS Code" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" className={styles.techIcon} alt="VS Code" />
                </div>
                <span className={styles.techName}>VS Code</span>
              </a>
            </div>

            {/* ROW 4 (6 items - Cloud & Virtualization) */}
            <div className={styles.techstackRow}>
              <a href="https://aws.amazon.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="AWS" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://img.icons8.com/color/48/amazon-web-services.png" className={styles.techIcon} alt="AWS" />
                </div>
                <span className={styles.techName}>AWS</span>
              </a>
              <a href="https://cloud.google.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="GCP" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg" className={styles.techIcon} alt="GCP" />
                </div>
                <span className={styles.techName}>GCP</span>
              </a>
              <a href="https://civo.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Civo" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://www.civo.com/assets-rebrand/logos/civo-black.svg" className={`${styles.techIcon} ${styles.invert}`} alt="Civo" />
                </div>
                <span className={styles.techName}>Civo</span>
              </a>
              <a href="https://docker.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Docker" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" className={styles.techIcon} alt="Docker" />
                </div>
                <span className={styles.techName}>Docker</span>
              </a>
              <a href="https://kubernetes.io" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Kubernetes" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg" className={styles.techIcon} alt="Kubernetes" />
                </div>
                <span className={styles.techName}>Kubernetes</span>
              </a>
              <a href="https://lit.dev" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Lit Component" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <svg viewBox="0 0 160 200" className={styles.techIcon}>
                    <path fill="#00e8ff" d="M40 120l20-60l90 90l-30 50l-40-40h-20"/>
                    <path fill="#283198" d="M80 160 L80 80 L120 40 L 120 120 M0 160 L40 200 L40 120 L20 120"/>
                    <path fill="#324fff" d="M40 120v-80l40-40v80M120 200v-80l40-40v80M0 160v-80l40 40"/>
                    <path fill="#00ffff" d="M40 200v-80l40 40"/>
                  </svg>
                </div>
                <span className={styles.techName}>Lit Component</span>
              </a>
            </div>

            {/* ROW 5 (4 items - CI/CD & Version Control) */}
            <div className={styles.techstackRow}>
              <a href="https://git-scm.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Git" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" className={styles.techIcon} alt="Git" />
                </div>
                <span className={styles.techName}>Git</span>
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="GitHub" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" className={`${styles.techIcon} ${styles.invert}`} alt="GitHub" />
                </div>
                <span className={styles.techName}>GitHub</span>
              </a>
              <a href="https://github.com/features/actions" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="GitHub Actions" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/githubactions/githubactions-original.svg" className={styles.techIcon} alt="GitHub Actions" />
                </div>
                <span className={styles.techName}>Git Actions</span>
              </a>
              <a href="https://jenkins.io" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Jenkins" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg" className={styles.techIcon} alt="Jenkins" />
                </div>
                <span className={styles.techName}>Jenkins</span>
              </a>
            </div>

            {/* ROW 6 (Hosting & Management - 2 items) */}
            <div className={styles.techstackRow}>
              <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Vercel" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg" className={`${styles.techIcon} ${styles.invert}`} alt="Vercel" />
                </div>
                <span className={styles.techName}>Vercel</span>
              </a>
              <a href="https://jira.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Jira" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jira/jira-original.svg" className={styles.techIcon} alt="Jira" />
                </div>
                <span className={styles.techName}>Jira</span>
              </a>
            </div>

            {/* ROW 7 (Pyramid Tip - 1 item) */}
            <div className={styles.techstackRow}>
              <a href="https://postman.com" target="_blank" rel="noopener noreferrer" className={styles.techstackItem} title="Postman" data-cursor="disable">
                <div className={styles.iconWrapper}>
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg" className={styles.techIcon} alt="Postman" />
                </div>
                <span className={styles.techName}>Postman</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MyServices
